import { Form } from "@circle-react-uikit/Form";
import type { CourseSetting } from "@circle-react/types/Space";

import { CourseTypePickerOptions } from "@/react/components/CoursesV2/CourseTypePickerOptions";
import { DEFAULT_COURSE_TYPE } from "@/react/components/Spaces/CourseSpace/CourseTypePicker/constants";

import { COURSE_TYPE_FORM_ID } from "../constants";

interface CourseTypeStepProps {
  initialValue?: CourseSetting;
  onConfirm: (courseSetting: CourseSetting) => void;
}

interface FormValues {
  course_setting: CourseSetting;
}

export const CourseTypeStep = ({
  initialValue,
  onConfirm,
}: CourseTypeStepProps) => (
  <Form<FormValues>
    id={COURSE_TYPE_FORM_ID}
    onSubmit={data => onConfirm(data.course_setting)}
    defaultValues={{
      course_setting: initialValue ?? { course_type: DEFAULT_COURSE_TYPE },
    }}
  >
    <CourseTypePickerOptions hideLabel />
  </Form>
);
